export const CLASS_SCHEDULE_COPY = {
	fewSeatsRemaining: {
		threshold: {
			key: "few-seats-remaining-threshold",
			fallback: "10",
		},
		badge: {
			key: "few-seats-remaining-badge",
			fallback: "Few seats remaining",
		},
	},
	startingSoon: {
		threshold: {
			key: "starting-soon-threshold",
			fallback: "14",
		},
		badge: {
			key: "starting-soon-badge",
			fallback: "Starting Soon",
		},
	},
} as const;
